$.fn.PostCategoryGrid = function(button) {
  let self = this

  self.wrap('<div class="post-category-grid-wrapper"></div>');
  second_col = self.clone()
  second_col.find('.grid__item').even().remove();
  self.find('.grid__item').odd().remove();
  second_col.insertAfter(self);

  return function() {
    return self
  }()
}
